const predicate =
  (weekDaysSelected) =>
  (itinerary): boolean => {
    const departureDay = new Date(
      itinerary.legs[0].segments[0].sections[0].departureDate
    ).getDay();
    const arrivalDay =
      itinerary.legs.length > 1
        ? new Date(
            itinerary.legs[1].segments[
              itinerary.legs[1].segments.length - 1
            ].departureDate
          ).getDay()
        : null;

    const noneSelected =
      weekDaysSelected.departureSelected.length === 0 &&
      weekDaysSelected.arrivalSelected.length === 0;
    const onlyDepartureSelected =
      weekDaysSelected.departureSelected.length > 0 &&
      weekDaysSelected.arrivalSelected.length === 0;
    const onlyArrivalSelected =
      weekDaysSelected.arrivalSelected.length > 0 &&
      weekDaysSelected.departureSelected.length === 0;
    const bothSelected =
      weekDaysSelected.departureSelected.length > 0 &&
      weekDaysSelected.arrivalSelected.length > 0;

    return (
      noneSelected ||
      (onlyDepartureSelected &&
        weekDaysSelected.departureSelected.includes(departureDay)) ||
      (onlyArrivalSelected &&
        weekDaysSelected.arrivalSelected.includes(arrivalDay)) ||
      (bothSelected &&
        weekDaysSelected.departureSelected.includes(departureDay) &&
        weekDaysSelected.arrivalSelected.includes(arrivalDay))
    );
  };

export default predicate;
